import { toast } from "react-hot-toast";
import classNames from "classnames";
import { MdOutlineClose } from "react-icons/md";
import { HiLightningBolt } from "react-icons/hi";
import moment from "moment";

export const numberFormat = (value, isCurrency = true) => {
  let options = {}
  
  if (isCurrency) {
    options = {
      style: 'currency',
      currency: 'IDR', 
      maximumFractionDigits: 0, 
      roundingMode: 'ceil'
    }
  }

  return new Intl.NumberFormat('en-ID', options).format(value);
}

export const hourFormat = (value) => 
  moment(value).format("HH:mm");

const style = {
  notificationWrapper: "flex flex-row items-center justify-between w-96 bg-green-700 px-4 py-6 text-white shadow-2xl hover:shadow-none transform-gpu translate-y-0 hover:translate-y-1 rounded-xl relative transition-all duration-500 ease-in-out",
  notificationWrapperError: "flex flex-row items-center justify-between w-96 bg-red-800 px-4 py-6 text-white shadow-2xl hover:shadow-none transform-gpu translate-y-0 hover:translate-y-1 rounded-xl relative transition-all duration-500 ease-in-out",
  iconWrapper: " text-xl",
  contentWrapper: "flex flex-grow flex-col items-start justify-center ml-4 cursor-default",
  contentWrapperH1: "text-base text-gray-200 font-semibold leading-none tracking-wider",
  contentWrapperP: "text-sm text-gray-300 mt-2 leading-relaxed tracking-wider",
  closeIcon: "absolute top-2 right-2 cursor-pointer text-lg"
}


export const showToast = (type, title, message) => {
  toast.custom(
    (t) => (
      <div
        className={
          type === "Error" ?
            classNames([
              style.notificationWrapperError,
              t.visible ? "top-0" : "-top-96",
            ])
            :
            classNames([
              style.notificationWrapper,
              t.visible ? "top-0" : "-top-96",
            ])

        }
      >
        <div className={style.iconWrapper}>
          <HiLightningBolt />
        </div>
        <div className={style.contentWrapper}>
          <h1 className={style.contentWrapperH1}>{title}</h1>
          <p className={style.contentWrapperP}>
            {message}
          </p>
        </div>
        <div className={style.closeIcon} onClick={() => toast.dismiss(t.id)}>
          <MdOutlineClose />
        </div>
      </div>
    ),
    { id: "unique-notification", position: "top-center" }
  );
}

export const capitalize = (str) => {
  return str
    .split(' ')  // Split string into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalize first letter and make the rest lowercase
    .join(' ');  // Join the array back into a string
};